module.exports = __webpack_public_path__ + "img/rkdgroup.f76169bb.png";